import { fieldName } from './fieldName';
import { fieldType } from './fieldType';

export default {
  namespaced: true,

  getters: {
    enabled(state, getters, rootState, rootGetters) {
      const config = rootGetters['builder/config'];
      return (
        !!config &&
        !!config.entities &&
        !!config.entities.fields
      );
    },

    label(state, getters, rootState, rootGetters) {
      return (field, entity) => {
        try {
          const typeLabel = fieldType(
            field,
            entity,
            rootGetters,
          );

          let label = `${fieldName(
            field,
            entity,
          )}: ${typeLabel}`;

          return label;
        } catch (error) {
          return `Error`;
        }
      };
    },
  },
};
